// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9045ad3","977":"40241624"}[chunkId] + ".chunk.js";
};